import { defineStore } from 'pinia'
import { ref } from 'vue'

/** Full-screen loading overlay for long-running dashboard operations (e.g. leave impersonation). */
export const useGlobalLoadingStore = defineStore('globalLoading', () => {
  const active = ref(false)

  function start() {
    active.value = true
  }

  function stop() {
    active.value = false
  }

  async function run<T>(fn: () => Promise<T>): Promise<T> {
    start()
    try {
      return await fn()
    } finally {
      stop()
    }
  }

  return {
    active,
    start,
    stop,
    run
  }
})
